module.exports = __webpack_public_path__ + "static/media/autopia-background.bda7916e.jpg";